export default __webpack_public_path__ + "static/media/1b-running-bond.13a023b3.jpg";